import React from 'react';
import Image from 'next/legacy/image';
import { Button, H3, Text } from 'atoms';
import { Fade } from "react-awesome-reveal";
import { useDispatchUi } from 'context/ui';
import { useRouter } from 'next/router';

interface Props {
    heading?: string;
    subhead?: string;
    img: any;
    richText: any;
    ctalabel?: string;
    ctalink?: string;
}

export const ContentBlock2 = (
    {
        heading,
        subhead,
        img,
        richText,
        ctalabel,
        ctalink
    }: Props) => {
    const dispatch: any = useDispatchUi();
    const router = useRouter();
    return (
        <div className='pcb'>
            <Fade>
                <div className='pcb__content'>
                    <div id='heading'>
                        <H3 mb={4} style={{ color: '#121651' }}>
                            {heading}
                        </H3>
                        <Text mb={4} style={{ color: '#4f4f4f', fontSize: '18px' }}>
                            {subhead}
                        </Text>
                    </div>
                    <div id='bottom'>
                        <div>
                            <Image
                                height={img.height}
                                width={img.width}
                                src={img.url}
                                loading='lazy'
                            />
                        </div>
                        <div>
                            <div
                                className='rich-text-block2'
                                dangerouslySetInnerHTML={{ __html: richText }}
                            />
                            {Boolean(ctalabel) && <Button
                                onClick={e => {
                                    e.preventDefault();
                                    if (ctalink) {
                                        router.push(ctalink);
                                    }
                                    // Dispatch({ type: 'OPEN_MODAL' });
                                }}
                            >
                                {ctalabel}
                            </Button>}
                        </div>
                    </div>
                </div>
            </Fade>
            <style jsx>{`
                .pcb {
                    background-color: #f9f9f9;
                    padding: 48px 60px;

                    .pcb__content {
                        max-width: 1200px;
                        margin: 0 auto;

                        #heading {
                            text-align: center;
                        }

                        #bottom {
                            color: #4f4f4f;
                            font-family: Avenir, 'Avenir', sans-serf;
                            font-size: 18px;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            > div {
                                width: 100%;
                                padding: 8px;
                            }
                        }
                    }
                }

                @media (max-width: 992px) {
                    .pcb {
                        padding: 48px 40px;
                    }

                    #bottom {
                        flex-direction: column;

                        > div {
                            padding: 0px;
                        }
                    }
                }

                @media (max-width: 480px) {
                    .pcb {
                        padding: 48px 20px;
                    }
                }
            `}</style>
        </div>
    );
};
